import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineCar } from 'react-icons/ai';
import { show } from 'redux-modal';
import { size, map } from 'lodash';
import Car from '../Cars/Car';
import { fetchCars } from '../../actions/carActions';
import { Button } from '../utils/forms/Button';

export default function MyCarsPage() {
  const dispatch = useDispatch();
  const cars = useSelector((state) => state.cars);

  useEffect(() => {
    dispatch(fetchCars());
  }, []);

  return (
    <>
      <Button
        type="button"
        size="sm"
        color="secondary"
        onClick={() => dispatch(show('newCarModal'))}
      >
        Nové auto
        <AiOutlineCar
          style={{ float: 'right', fontSize: 24, marginLeft: 10, marginTop: 7 }}
        />
      </Button>
      <div className="scrollable mt2" style={{ maxHeight: 265 }}>
        {size(cars) > 0 ? (
          map(cars, (car) => <Car key={car.plateNo} data={car} />)
        ) : (
          <div className="center">Zatím nemáte přidané žádné auto.</div>
        )}
      </div>
    </>
  );
}
